module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmWUlfBBc4.2735a3a6.woff2";